import { Debugger } from "debug";
import { FileLogger } from "@logger";
import { BaseConnection } from "connection/_base.connection";

export type TApiLogger = FileLogger | Debugger | Console;
export type TApiLoggerOpt = FileLogger | Debugger | Console | null;

export type TMysqlExecOpts = {
	fields?: string[],
	filter?: any,
	orderBy?: string,
	offset?: number,
	limit?: number,
	modelData?: any
};

export type TComplexCondition = {
	[key: string]: TSimpleCondition
};

export type TSimpleCondition = string | number | boolean | Date | string[] | number[];

export type TMultipelCondition = (TComplexCondition | TSimpleCondition)[];

export type TFollowOptions = string[] | "*";

export enum EQueryOperators {
	eq = "=",
	neq = "<>",
	like = "LIKE",
	notlike = "NOT LIKE",
	in = "IN",
	notin = "NOT IN",
	notnull = "IS NOT NULL",
	null = "IS NULL",
	gt = ">",
	lt = "<",
	gteq = ">=",
	lteq = "<="
}

export enum EJoinTypes {
	inner = "INNER JOIN",
	left = "LEFT JOIN",
	right = "RIGHT JOIN",
	outer = "OUTER JOIN"
}

export enum EQueryTypes {
	select = "SELECT",
	insert = "INSERT",
	update = "UPDATE",
	delete = "DELETE"
}

export type TPaginatedTotals = {
	page: number,
	pageSize: number,
	totalPages: number,
	thisPageCount: number,
	totalCount: number,
	hasNextPage: boolean,
	hasPreviousPage: boolean
};

export interface IEnvironment {
	readonly code: string;
	readonly name: string;

	validate(): void;

	getConnection(): BaseConnection;
}